"use strict";

exports.__esModule = true;
exports.AdvancedDataTableColumnWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _AdvancedDataTableColumnElement = require("./AdvancedDataTableColumnElement");
var _AdvancedDataTableColumnFields = require("./AdvancedDataTableColumnFields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedDataTableColumnWidget = exports.AdvancedDataTableColumnWidget = {
  name: "AdvancedDataTableColumn",
  icon: "th",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedDataTableColumnWidget.label",
    defaultMessage: "Column"
  }),
  getElementLabel: function getElementLabel(element) {
    return element.props.label || element.props.name;
  },
  createElement: function createElement(props) {
    return {
      type: "AdvancedDataTableColumn",
      props: Object.assign({}, props),
      children: []
    };
  },
  children: [],
  showInPalette: false,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color"],
  requiresProps: [],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _AdvancedDataTableColumnElement.AdvancedDataTableColumnElement,
    Fields: _AdvancedDataTableColumnFields.AdvancedDataTableColumnFields
  }
};